<template>
  <v-tooltip max-width="200" right>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        v-bind="attrs"
        v-on="on"
        close
        @click:close="$emit('remove', keyToDisplay)"
        class="mr-1 text-capitalize secondary app-chips"
        close-icon="mdi-close-thick"
        x-small
      >
        <span v-if="keyToDisplay">
          {{ keyToDisplay.replaceAll("_", " ") }}</span
        >
      </v-chip>
    </template>
    <span
      v-if="
        keyToDisplay == 'sort_by' &&
        valueToDisplay &&
        typeof valueToDisplay == 'string'
      "
      class="text-capitalize"
      >{{
        valueToDisplay.charAt(0) == "-"
          ? valueToDisplay.replace(/-/g, "Descending - ").replace(/_/g, " ")
          : `Ascending - ${valueToDisplay.replace(/_/g, " ")}`
      }}
    </span>
    <span
      v-else-if="valueToDisplay && typeof valueToDisplay == 'string'"
      class="text-capitalize"
      >{{ valueToDisplay.replace(/_/g, " ") }}</span
    >
    <span v-else-if="Array.isArray(valueToDisplay)" class="text-capitalize">{{
      valueToDisplay.map((string) => string.replace(/_/g, " ")).join(", ")
    }}</span>
    <span
      v-else-if="typeof valueToDisplay == typeof true"
      class="text-capitalize"
    >
      {{ valueToDisplay ? "Yes" : "No" }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  emits: ["remove"],
  props: {
    keyToDisplay: {
      type: String,
    },
    valueToDisplay: {
      type: [Array, String, Number, Boolean],
    },
  },
};
</script>

<style></style>
